import React from 'react';

const APPROACH_IMAGE = `${process.env.PUBLIC_URL || ''}/images/section-images/${encodeURIComponent('home cta.jpg')}`;

export default function AboutStrategicApproach(): React.ReactElement {
  return (
    <section className="bg-sky-600">
      <div className="mx-auto w-full max-w-7xl px-4 py-16 sm:px-6 lg:px-12 lg:py-20">
        <div className="grid gap-6 lg:grid-cols-2 lg:gap-8">
          {/* Text Content Section - Left */}
          <div className="flex flex-col justify-center">
            <div className="text-left">
              <h2 className="text-3xl font-semibold leading-tight text-white sm:text-4xl">
                Our Strategic Approach: Lean Six Sigma
              </h2>
              <p className="mt-6 text-sm leading-relaxed text-white/90 sm:text-base">
                At the heart of our operations is the Lean Six Sigma management approach. We don't just
                complete projects; we optimize them. This methodology ensures:
              </p>
              <ul className="mt-6 space-y-4 text-sm leading-relaxed text-white/90 sm:text-base">
                <li className="flex items-start">
                  <span className="mr-3 mt-1 flex-shrink-0 text-white">•</span>
                  <span>
                    <strong className="font-semibold text-white">Zero Defects:</strong> Rigorous quality
                    control at every stage of fabrication and installation.
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="mr-3 mt-1 flex-shrink-0 text-white">•</span>
                  <span>
                    <strong className="font-semibold text-white">Reduced Lead Times:</strong> Streamlined
                    workflows that get your plant back online faster.
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="mr-3 mt-1 flex-shrink-0 text-white">•</span>
                  <span>
                    <strong className="font-semibold text-white">Continuous Improvement:</strong> We
                    analyze every project outcome to refine our future service delivery.
                  </span>
                </li>
              </ul>
            </div>
          </div>

          {/* Image Section - Right */}
          <div>
            <div className="relative h-full min-h-[400px] w-full overflow-hidden rounded-xl bg-slate-100 sm:min-h-[450px]">
              <img
                src={APPROACH_IMAGE}
                alt="Lean Six Sigma Strategic Approach"
                className="h-full w-full object-cover object-center"
                loading="lazy"
                onError={(e) => {
                  console.error('Failed to load image:', APPROACH_IMAGE);
                }}
                onLoad={() => {
                  console.log('AboutStrategicApproach image loaded successfully:', APPROACH_IMAGE);
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
